import moment from "moment";
import React, { Component } from "react";
import connect from "react-redux/es/connect/connect";
import BelgiumMapPaper from "../../components/Admin/EventStats/EventRegistrantLinechart/BelgiumMapPaper";
import { Row, Col } from "antd";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { formatAmount, newSeasonFilterStyle } from "../../services/utils";
import { getNbrInscritsCAPaperByRegion, getRapportCAPaper, getRapportInscritsPaper, startCommandGetNbrCaPaperByFrequency, startCommandGetNbrInscritBySilot, startCommandGetSilotDetails } from "../../actions/thunks/eventStats";
import { CommonLoader } from "../../components/common/CommonLoader";
import PaperFilterInscriptionsCA from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperFilterInscriptionsCA";
import PaperChart from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperChart";
import t from "i18n";
import _ from "i18n";
import PaperStatsChartLineType from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineType";
import PaperFilterTypeSilo from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperFilterTypeSilo";
import PaperInscriptionsCAType from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCAType";
import ReactSelect, { components } from "react-select";
import { getCommandInfo } from "../../actions/thunks/statistics";
import PaperInscriptionsCASilo from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCASilo";
import { data } from "jquery";
import PaperStatsChartLineSilo from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineSilo";
import PaperInscriptionsCATypeCompare from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCATypeCompare";
import PaperStatsChartLineTypeCompare from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineTypeCompare";
import PaperInscriptionsCASiloCompare from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCASiloCompare";
import PaperStatsChartLineSiloCompare from "../../components/Admin/EventStats/EventRegistrantLinechart/PaperStatsChartLineSiloCompare";
import MonthFilterPaper from "../../components/Filters/EventStats/CompareStats/MonthFilterPaper";
import PeriodFilterPaper from "../../components/Filters/EventStats/PeriodFilterPaper";

const DropdownIndicator = props => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={"/img/icons/Polygon.svg"} className={'mr-1'} />
        </components.DropdownIndicator>
    );
};
class PaperStatisticsPage extends Component {

    constructor(props) {
        super(props);
        const currentYear = new Date().getFullYear();

        // Generate months: 01 to 12
        const monthsForDailyForSelect = Array.from({ length: 12 }, (_, i) => {
            const month = String(i + 1).padStart(2, '0');
            return {
                label: `${month}/${currentYear}`,
                value: `${currentYear}-${month}`,
            };
        });
        this.state = {
            period: currentYear,
            cityPercentageData: {},
            topFiveCityPercentageData: [],
            nbrInscriptionFetch: false,
            typeInscritData: {},
            typeInscritFetch: false,
            typeCAData: {},
            typeCAFetch: false,
            activeTabInscriptionsCA: 'inscriptions',
            activeTabTypeSilo: 'type',
            selectedFrequency: 'MONTHLY',
            visibleKeysType: ['individuel', 'fiduciare'],
            visibleKeysSilo: [4, 6, 9],
            silotData: {},
            silotDataFetch: false,
            silotData2: {},
            silotDataFetch2: false,
            selectedMonth: monthsForDailyForSelect[new Date().getMonth()].value,
            monthsForDailyForSelect,
            monthsForDailyForSelectDefault: monthsForDailyForSelect[new Date().getMonth()],
            showCompareStats: false,
            showCompareStatsByType: { individuel: false, fiduciare: false, all: false },
            showCompareStatsFetch: false,
            silotDataActivities: {},
            silotDataActivitiesFetch: false,
            openIndex: null,
            silotDetails: {},
            silotDetailsFetch: false,
            startMonth: '01',
            endMonth: '12',
            firstVariant: 10,
            secondVariant: 5,
            thirdVariant: 0,
        };
    }

    getValuesFromLocalStorage = () => {
        const startMonth = localStorage.getItem('startMonthPaperStats');
        if (startMonth) {
            this.setState({ startMonth })
        }
        const endMonth = localStorage.getItem('endMonthPaperStats');
        if (endMonth) {
            this.setState({ endMonth })
        }
    }

    handleStartMonthChange = (startMonth) => {
        const { endMonth } = this.state;
        if (startMonth > endMonth) {
            this.setState({ endMonth: startMonth });
            localStorage.setItem('endMonthPaperStats' , startMonth);
        }
        this.setState({ startMonth });
        localStorage.setItem('startMonthPaperStats' , startMonth);
    };

    handleEndMonthChange = (endMonth) => {
        const { startMonth } = this.state;
        if (endMonth < startMonth) {
            this.setState({ startMonth: endMonth });
            localStorage.setItem('startMonthPaperStats' , endMonth);
        }
        this.setState({ endMonth });
        localStorage.setItem('endMonthPaperStats' , endMonth);
    };

    handleSelectChange = (selectedOption) => {
        this.setState({ selectedMonth: selectedOption.value });
    };

    getRandomColor() {
        const hue = Math.floor(Math.random() * 360); // full color wheel
        const saturation = 70 + Math.random() * 20; // 70–90% vivid
        const lightness = 45 + Math.random() * 15;  // 45–60% clear visibility

        return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }

    addColorsToSilos(data) {
        const colorMap = {}; // to keep the same color for the same silot
        const coloredData = {};

        Object.entries(data).forEach(([month, silos]) => {
            coloredData[month] = {};
            Object.entries(silos).forEach(([silotId, silot]) => {
                if (!colorMap[silot.silotName]) {
                    colorMap[silot.silotName] = this.getRandomColor();
                }
                coloredData[month][silotId] = {
                    ...silot,
                    color: colorMap[silot.silotName],
                };
            });
        });

        return coloredData;
    }

    addColorsToBothSilos(data1, data2) {
        const colorMap = {};
        const getColor = (silotName) => {
            if (!colorMap[silotName]) {
                colorMap[silotName] = this.getRandomColor();
            }
            return colorMap[silotName];
        };

        const colorize = (data) => {
            const coloredData = {};
            Object.entries(data).forEach(([month, silos]) => {
                coloredData[month] = {};
                Object.entries(silos).forEach(([silotId, silot]) => {
                    const color = getColor(silot.silotName);
                    coloredData[month][silotId] = {
                        ...silot,
                        color,
                    };
                });
            });
            return coloredData;
        };

        const coloredData1 = colorize(data1);
        const coloredData2 = colorize(data2);

        return { coloredData1, coloredData2 };
    }

    componentDidMount() {
        const { eventStatsFilter } = this.props;
        const { selectedFrequency, period } = this.state;

        this.currSilotRequestId = null;
        this.currCARequestId = null;

        this.getValuesFromLocalStorage();

        this.setState({ silotDataFetch: true, nbrInscriptionFetch: true, typeInscritFetch: true, silotDataActivitiesFetch: false });

        this.props.startCommandGetNbrInscritBySilot([period]).then((res) => {
            // Clear previous timer
            clearInterval(this.silotTimer);

            const startSilotTimer = () => {
                // Pour éviter des requête concurrentes
                this.currSilotRequestId = `SILOT_${performance.now()}`;
                let prevRequestId = this.currSilotRequestId;

                this.props.getCommandInfo(res.value.data.data.command.id)
                    .then((resultat) => {

                        if (prevRequestId !== this.currSilotRequestId) {
                            return;
                        }

                        if (resultat.data.data.status !== "FINISHED") {
                            this.setState({ silotDataActivitiesFetch: true });
                            return;
                        }

                        this.setState({ silotDataActivities: resultat.data.data.result, silotDataActivitiesFetch: false });

                        clearInterval(this.silotTimer);

                    })
                    .catch(() => {
                        clearInterval(this.silotTimer);
                    });
            }

            this.silotTimer = setInterval(startSilotTimer, 3000);
        });

        this.props.startCommandGetNbrCaPaperByFrequency([period], selectedFrequency).then((res) => {
            // Clear previous timer
            clearInterval(this.caTimer);

            const startCATimer = () => {
                // Pour éviter des requête concurrentes
                this.currCARequestId = `CA_${performance.now()}`;
                let prevRequestId = this.currCARequestId;

                this.props.getCommandInfo(res.value.data.data.command.id)
                    .then((resultat) => {

                        if (prevRequestId !== this.currCARequestId) {
                            return;
                        }

                        if (resultat.data.data.status !== "FINISHED") {
                            this.setState({ silotDataFetch: true });
                            return;
                        }

                        const silotIds = [
                            ...new Set(
                                Object.values(resultat.data.data.result)
                                    .flatMap(month => Object.values(month).map(silot => silot.silotId))
                            )
                        ];

                        const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                        this.setState({ silotData: coloredSiloData, visibleKeysSilo: silotIds, silotDataFetch: false });

                        clearInterval(this.caTimer);

                    })
                    .catch(() => {
                        clearInterval(this.caTimer);
                    });
            }

            this.caTimer = setInterval(startCATimer, 3000);
        });

        this.props.getNbrInscritsCAPaperByRegion([period]).then((res) => {
            const allData = Object.values(res.value.data.data);

            // 1️⃣ Create the cityPercentageData map
            const cityPercentageData = allData.reduce((acc, item) => {
                const regionKey = item.region;
                acc[regionKey] = [item.nbrInscription, item.ca];
                return acc;
            }, {});

            // 2️⃣ Filter out "Others" before sorting
            const filteredData = allData.filter(item => item.region !== "Others");

            // 3️⃣ Sort and get top 5 real regions
            const sortedData = filteredData.sort((a, b) => b.ca - a.ca);
            const topFiveCityPercentageData = sortedData.slice(0, 5);

            // 4️⃣ Calculate "Others" = sum of remaining regions (not in top 5)
            const remainingRegions = sortedData.slice(5);
            let othersTotals = remainingRegions.reduce(
                (acc, item) => {
                    acc.nbrInscription += item.nbrInscription;
                    acc.ca += item.ca;
                    return acc;
                },
                { region: "Others", nbrInscription: 0, ca: 0 }
            );

            const filteredDataOthers = allData.filter(item => item.region === "Others");
            othersTotals.nbrInscription += filteredDataOthers.length > 0 ? filteredDataOthers[0].nbrInscription : 0;
            othersTotals.ca += filteredDataOthers.length > 0 ? filteredDataOthers[0].ca : 0;

            // 5️⃣ Combine top 5 + recalculated "Others"
            const finalCityList = [...topFiveCityPercentageData, othersTotals];

            // 6️⃣ Update state
            this.setState({
                cityPercentageData,
                topFiveCityPercentageData: finalCityList,
                nbrInscriptionFetch: false
            });
        });

        this.props.getRapportInscritsPaper([period]).then((res) => {
            this.setState({ typeInscritData: res.value.data.data, typeInscritFetch: false });
        });

        this.props.getRapportCAPaper([period]).then((res) => {
            this.setState({ typeCAData: res.value.data.data, typeCAFetch: false });
        });
    };

    componentDidUpdate(prevProps, prevState) {
        const { eventStatsFilter } = this.props;
        const { selectedFrequency, selectedMonth, showCompareStats, showCompareStatsByType, period } = this.state;

        if (prevState.period !== this.state.period) {
            this.setState({ silotDataActivitiesFetch: true, nbrInscriptionFetch: true, typeInscritFetch: true, typeCAFetch: true });
            this.props.startCommandGetNbrInscritBySilot([period]).then((res) => {
                // Clear previous timer
                clearInterval(this.silotTimer);

                const startSilotTimer = () => {
                    // Pour éviter des requête concurrentes
                    this.currRequestId = `SILOT_${performance.now()}`;
                    let prevRequestId = this.currRequestId;

                    this.props.getCommandInfo(res.value.data.data.command.id)
                        .then((resultat) => {

                            if (prevRequestId !== this.currRequestId) {
                                return;
                            }

                            if (resultat.data.data.status !== "FINISHED") {
                                this.setState({ silotDataActivitiesFetch: true });
                                return;
                            }

                            this.setState({ silotDataActivities: resultat.data.data.result, silotDataActivitiesFetch: false });

                            clearInterval(this.silotTimer);

                        })
                        .catch(() => {
                            clearInterval(this.silotTimer);
                        });
                }

                this.silotTimer = setInterval(startSilotTimer, 3000);
            });

            this.props.getNbrInscritsCAPaperByRegion([period]).then((res) => {
                const allData = Object.values(res.value.data.data);

                // 1️⃣ Create the cityPercentageData map
                const cityPercentageData = allData.reduce((acc, item) => {
                    const regionKey = item.region;
                    acc[regionKey] = [item.nbrInscription, item.ca];
                    return acc;
                }, {});

                // 2️⃣ Filter out "Others" before sorting
                const filteredData = allData.filter(item => item.region !== "Others");

                // 3️⃣ Sort and get top 5 real regions
                const sortedData = filteredData.sort((a, b) => b.ca - a.ca);
                const topFiveCityPercentageData = sortedData.slice(0, 5);

                // 4️⃣ Calculate "Others" = sum of remaining regions (not in top 5)
                const remainingRegions = sortedData.slice(5);
                let othersTotals = remainingRegions.reduce(
                    (acc, item) => {
                        acc.nbrInscription += item.nbrInscription;
                        acc.ca += item.ca;
                        return acc;
                    },
                    { region: "Others", nbrInscription: 0, ca: 0 }
                );

                const filteredDataOthers = allData.filter(item => item.region === "Others");
                othersTotals.nbrInscription += filteredDataOthers.length > 0 ? filteredDataOthers[0].nbrInscription : 0;
                othersTotals.ca += filteredDataOthers.length > 0 ? filteredDataOthers[0].ca : 0;

                // 5️⃣ Combine top 5 + recalculated "Others"
                const finalCityList = [...topFiveCityPercentageData, othersTotals];

                // 6️⃣ Update state
                this.setState({
                    cityPercentageData,
                    topFiveCityPercentageData: finalCityList,
                    nbrInscriptionFetch: false
                });
            });

            this.props.getRapportInscritsPaper([period]).then((res) => {
                this.setState({ typeInscritData: res.value.data.data, typeInscritFetch: false });
            });

            this.props.getRapportCAPaper([period]).then((res) => {
                this.setState({ typeCAData: res.value.data.data, typeCAFetch: false });
            });
        }

        if (prevState.selectedFrequency !== selectedFrequency || prevState.period !== period || prevState.selectedMonth !== selectedMonth) {
            if (selectedFrequency === "MONTHLY") {
                this.setState({ silotDataFetch: true });
                this.props.startCommandGetNbrCaPaperByFrequency([period], selectedFrequency).then((res) => {
                    // Clear previous timer
                    clearInterval(this.commandTimer);

                    const startCommandTimer = () => {
                        // Pour éviter des requête concurrentes
                        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                        let prevRequestId = this.currRequestId;

                        this.props.getCommandInfo(res.value.data.data.command.id)
                            .then((resultat) => {

                                if (prevRequestId !== this.currRequestId) {
                                    return;
                                }

                                if (resultat.data.data.status !== "FINISHED") {
                                    this.setState({ silotDataFetch: true });
                                    return;
                                }

                                const silotIds = [
                                    ...new Set(
                                        Object.values(resultat.data.data.result)
                                            .flatMap(month => Object.values(month).map(silot => silot.silotId))
                                    )
                                ];

                                const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                                this.setState({ silotData: coloredSiloData, visibleKeysSilo: silotIds, silotDataFetch: false });

                                clearInterval(this.commandTimer);

                            })
                            .catch(() => {
                                clearInterval(this.commandTimer);
                            });
                    }

                    this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
            }

            if (selectedFrequency === "DAILY") {
                this.setState({ silotDataFetch: true });
                this.props.startCommandGetNbrCaPaperByFrequency([period], selectedFrequency, selectedMonth).then((res) => {
                    // Clear previous timer
                    clearInterval(this.commandTimer);

                    const startCommandTimer = () => {
                        // Pour éviter des requête concurrentes
                        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                        let prevRequestId = this.currRequestId;

                        this.props.getCommandInfo(res.value.data.data.command.id)
                            .then((resultat) => {

                                if (prevRequestId !== this.currRequestId) {
                                    return;
                                }

                                if (resultat.data.data.status !== "FINISHED") {
                                    this.setState({ silotDataFetch: true });
                                    return;
                                }

                                const silotIds = [
                                    ...new Set(
                                        Object.values(resultat.data.data.result)
                                            .flatMap(month => Object.values(month).map(silot => silot.silotId))
                                    )
                                ];

                                const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                                this.setState({ silotData: coloredSiloData, visibleKeysSilo: silotIds, silotDataFetch: false });

                                clearInterval(this.commandTimer);

                            })
                            .catch(() => {
                                clearInterval(this.commandTimer);
                            });
                    }

                    this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
            }

            if (selectedFrequency === "YEARLY") {
                this.setState({ silotDataFetch: true });
                this.props.startCommandGetNbrCaPaperByFrequency(null, selectedFrequency).then((res) => {
                    // Clear previous timer
                    clearInterval(this.commandTimer);

                    const startCommandTimer = () => {
                        // Pour éviter des requête concurrentes
                        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                        let prevRequestId = this.currRequestId;

                        this.props.getCommandInfo(res.value.data.data.command.id)
                            .then((resultat) => {

                                if (prevRequestId !== this.currRequestId) {
                                    return;
                                }

                                if (resultat.data.data.status !== "FINISHED") {
                                    this.setState({ silotDataFetch: true });
                                    return;
                                }

                                const silotIds = [
                                    ...new Set(
                                        Object.values(resultat.data.data.result)
                                            .flatMap(month => Object.values(month).map(silot => silot.silotId))
                                    )
                                ];

                                const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                                this.setState({ silotData: coloredSiloData, visibleKeysSilo: silotIds, silotDataFetch: false });

                                clearInterval(this.commandTimer);

                            })
                            .catch(() => {
                                clearInterval(this.commandTimer);
                            });
                    }

                    this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
            }
        }

        if (prevState.showCompareStatsByType !== showCompareStatsByType && (showCompareStatsByType.individuel || showCompareStatsByType.fiduciare || showCompareStatsByType.all)) {
            this.setState({ showCompareStatsFetch: true });
        }

        if (prevState.showCompareStats !== showCompareStats && showCompareStats || (prevState.showCompareStatsByType !== showCompareStatsByType && (showCompareStatsByType.individuel || showCompareStatsByType.fiduciare || showCompareStatsByType.all))) {
            if (selectedFrequency === "MONTHLY") {
                this.setState({ silotDataFetch2: true });

                this.props.startCommandGetNbrCaPaperByFrequency([period - 1], selectedFrequency).then((res) => {
                    // Clear previous timer
                    clearInterval(this.commandTimer);

                    const startCommandTimer = () => {
                        // Pour éviter des requête concurrentes
                        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                        let prevRequestId = this.currRequestId;

                        this.props.getCommandInfo(res.value.data.data.command.id)
                            .then((resultat) => {

                                if (prevRequestId !== this.currRequestId) {
                                    return;
                                }

                                if (resultat.data.data.status !== "FINISHED") {
                                    this.setState({ silotDataFetch2: true });
                                    return;
                                }

                                const silotIds = [
                                    ...new Set(
                                        Object.values(resultat.data.data.result)
                                            .flatMap(month => Object.values(month).map(silot => silot.silotId))
                                    )
                                ];

                                const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                                const { silotData } = this.state;

                                const { coloredData1, coloredData2 } = this.addColorsToBothSilos(silotData, coloredSiloData);

                                this.setState({ silotData1: coloredData1, silotData2: coloredData2, visibleKeysSilo: silotIds, silotDataFetch2: false, showCompareStatsFetch: false });

                                clearInterval(this.commandTimer);

                            })
                            .catch(() => {
                                clearInterval(this.commandTimer);
                            });
                    }

                    this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
            }

            if (selectedFrequency === "DAILY") {
                this.setState({ silotDataFetch2: true });
                const [year, month] = selectedMonth.split("-");
                this.props.startCommandGetNbrCaPaperByFrequency([period - 1], selectedFrequency, `${year - 1}-${month}`).then((res) => {
                    // Clear previous timer
                    clearInterval(this.commandTimer);

                    const startCommandTimer = () => {
                        // Pour éviter des requête concurrentes
                        this.currRequestId = `COMMAND_REQUEST_${performance.now()}`;
                        let prevRequestId = this.currRequestId;

                        this.props.getCommandInfo(res.value.data.data.command.id)
                            .then((resultat) => {

                                if (prevRequestId !== this.currRequestId) {
                                    return;
                                }

                                if (resultat.data.data.status !== "FINISHED") {
                                    this.setState({ silotDataFetch2: true });
                                    return;
                                }

                                const silotIds = [
                                    ...new Set(
                                        Object.values(resultat.data.data.result)
                                            .flatMap(month => Object.values(month).map(silot => silot.silotId))
                                    )
                                ];

                                const coloredSiloData = this.addColorsToSilos(resultat.data.data.result);

                                this.setState({ silotData2: coloredSiloData, visibleKeysSilo: silotIds, silotDataFetch2: false, showCompareStatsFetch: false });

                                clearInterval(this.commandTimer);

                            })
                            .catch(() => {
                                clearInterval(this.commandTimer);
                            });
                    }

                    this.commandTimer = setInterval(startCommandTimer, 3 * 1000);
                });
            }

            if (selectedFrequency === "YEARLY") { }
        }
    };

    handleChangePeriod = (period) => {
        this.setState({ period });
    };

    handleActiveTabTypeSiloChange = (tab) => {
        this.setState({ activeTabTypeSilo: tab });
    };

    handleActiveTabInscriptionsCAChange = (tab) => {
        this.setState({ activeTabInscriptionsCA: tab });
    };

    handleFrequencyChange = (frequency) => {
        this.setState({ selectedFrequency: frequency, showCompareStats: false, showCompareStatsByType: { individuel: false, fiduciare: false, all: false } });
    };

    handleToggleKeyType = (key) => {
        this.setState(prev => ({
            visibleKeysType: prev.visibleKeysType.includes(key)
                ? prev.visibleKeysType.filter(k => k !== key)
                : [...prev.visibleKeysType, key]
        }));
    };

    handleToggleKeySilo = (key) => {
        this.setState(prev => ({
            visibleKeysSilo: prev.visibleKeysSilo.includes(key)
                ? prev.visibleKeysSilo.filter(k => k !== key)
                : [...prev.visibleKeysSilo, key]
        }));
    };

    handleShowCompareStats = (show) => {
        const { silotDataFetch, showCompareStatsByType } = this.state;
        if (silotDataFetch || (showCompareStatsByType.all || showCompareStatsByType.individuel || showCompareStatsByType.fiduciare)) return;
        this.setState({ showCompareStats: show, showCompareStatsByType: { individuel: false, fiduciare: false, all: false } });
    };

    handleShowCompareStatsByType = (show) => {
        this.setState((prevState) => {
            const current = prevState.showCompareStatsByType;

            if (current[show]) {
                return { showCompareStatsByType: { individuel: false, fiduciare: false, all: false } };
            }

            if (show === "all") {
                return { showCompareStatsByType: { individuel: false, fiduciare: false, all: true } };
            } else if (show === "individuel") {
                return { showCompareStatsByType: { individuel: true, fiduciare: false, all: false } };
            } else if (show === "fiduciare") {
                return { showCompareStatsByType: { individuel: false, fiduciare: true, all: false } };
            }

            return null;
        });
    };

    handleToggleDetails = (index, silotId) => {
        const { eventStatsFilter } = this.props;
        const { period } = this.state;
        this.setState(prevState => ({
            openIndex: prevState.openIndex === index ? null : index,
            silotDetailsFetch: true
        }));

        if (this.state.openIndex === index) {
            return;
        }

        this.props.startCommandGetSilotDetails(silotId, [period]).then((res) => {
            this.setState({ silotDetails: res.value.data.data, silotDetailsFetch: false });
        });
    };

    render() {
        // const yearsOptions = [
        //     { value: (moment().format('YYYY')), label: (moment().format('YYYY')) },
        //     { value: (moment().format('YYYY') - 1), label: (moment().format('YYYY')) - 1 },
        // ];
        const { activeTabInscriptionsCA, topFiveCityPercentageData, nbrInscriptionFetch, typeInscritData, typeInscritFetch, typeCAData, typeCAFetch, activeTabTypeSilo, selectedFrequency, visibleKeysType, silotData, silotDataFetch, monthsForDailyForSelect, monthsForDailyForSelectDefault, visibleKeysSilo, showCompareStats, silotData2, silotDataFetch2, showCompareStatsByType, showCompareStatsFetch, silotDataActivities, silotDataActivitiesFetch, openIndex, silotDetailsFetch, silotDetails, startMonth, endMonth, firstVariant, secondVariant, thirdVariant, period } = this.state;
        const { eventStatsFilter } = this.props;

        // const data1 = {
        //     "2025-01": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 10, individuelCa: 1000, fiduciareNbrInscrit: 5, fiduciareCa: 800 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 6, individuelCa: 600, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //     },
        //     "2025-02": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 12, individuelCa: 1150, fiduciareNbrInscrit: 6, fiduciareCa: 900 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 7, individuelCa: 750, fiduciareNbrInscrit: 4, fiduciareCa: 500 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //     },
        //     "2025-03": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 14, individuelCa: 1300, fiduciareNbrInscrit: 7, fiduciareCa: 950 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 850, fiduciareNbrInscrit: 3, fiduciareCa: 420 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //     },
        //     "2025-04": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 9, individuelCa: 940, fiduciareNbrInscrit: 5, fiduciareCa: 770 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 6, individuelCa: 580, fiduciareNbrInscrit: 2, fiduciareCa: 300 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },

        //     },
        //     "2025-05": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 13, individuelCa: 1200, fiduciareNbrInscrit: 6, fiduciareCa: 870 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 5, individuelCa: 500, fiduciareNbrInscrit: 4, fiduciareCa: 460 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },

        //     },
        //     "2025-06": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 15, individuelCa: 1450, fiduciareNbrInscrit: 8, fiduciareCa: 1000 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 9, individuelCa: 890, fiduciareNbrInscrit: 5, fiduciareCa: 520 },
        //     },
        //     "2025-07": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 11, individuelCa: 1100, fiduciareNbrInscrit: 6, fiduciareCa: 820 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 7, individuelCa: 700, fiduciareNbrInscrit: 3, fiduciareCa: 350 },
        //     },
        //     "2025-08": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 8, individuelCa: 850, fiduciareNbrInscrit: 4, fiduciareCa: 600 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 5, individuelCa: 520, fiduciareNbrInscrit: 3, fiduciareCa: 380 },
        //     },
        //     "2025-09": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 16, individuelCa: 1500, fiduciareNbrInscrit: 9, fiduciareCa: 1100 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 830, fiduciareNbrInscrit: 4, fiduciareCa: 480 },
        //     },
        //     "2025-10": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 13, individuelCa: 1280, fiduciareNbrInscrit: 6, fiduciareCa: 900 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 6, individuelCa: 630, fiduciareNbrInscrit: 3, fiduciareCa: 420 },
        //     },
        //     "2025-11": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 12, individuelCa: 1170, fiduciareNbrInscrit: 5, fiduciareCa: 790 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 7, individuelCa: 720, fiduciareNbrInscrit: 4, fiduciareCa: 460 },
        //     },
        //     "2025-12": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 0, fiduciareCa: 0 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 0, individuelCa: 0, fiduciareNbrInscrit: 0, fiduciareCa: 0 },
        //     },
        // };

        // const data2 = {
        //     "2024-01": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 8, individuelCa: 950, fiduciareNbrInscrit: 4, fiduciareCa: 700 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 5, individuelCa: 520, fiduciareNbrInscrit: 3, fiduciareCa: 360 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 1, individuelCa: 120, fiduciareNbrInscrit: 2, fiduciareCa: 250 },
        //     },
        //     "2024-02": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 10, individuelCa: 1100, fiduciareNbrInscrit: 5, fiduciareCa: 800 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 6, individuelCa: 580, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 2, individuelCa: 220, fiduciareNbrInscrit: 2, fiduciareCa: 300 },
        //     },
        //     "2024-03": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 12, individuelCa: 1250, fiduciareNbrInscrit: 6, fiduciareCa: 900 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 720, fiduciareNbrInscrit: 3, fiduciareCa: 410 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 2, individuelCa: 210, fiduciareNbrInscrit: 3, fiduciareCa: 350 },
        //     },
        //     "2024-04": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 11, individuelCa: 1180, fiduciareNbrInscrit: 5, fiduciareCa: 850 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 7, individuelCa: 650, fiduciareNbrInscrit: 4, fiduciareCa: 470 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 270, fiduciareNbrInscrit: 3, fiduciareCa: 340 },
        //     },
        //     "2024-05": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 13, individuelCa: 1300, fiduciareNbrInscrit: 6, fiduciareCa: 940 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 740, fiduciareNbrInscrit: 4, fiduciareCa: 500 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 280, fiduciareNbrInscrit: 3, fiduciareCa: 360 },
        //     },
        //     "2024-06": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 15, individuelCa: 1420, fiduciareNbrInscrit: 8, fiduciareCa: 1050 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 9, individuelCa: 850, fiduciareNbrInscrit: 5, fiduciareCa: 560 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 4, individuelCa: 340, fiduciareNbrInscrit: 3, fiduciareCa: 370 },
        //     },
        //     "2024-07": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 14, individuelCa: 1380, fiduciareNbrInscrit: 7, fiduciareCa: 1000 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 780, fiduciareNbrInscrit: 4, fiduciareCa: 510 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 300, fiduciareNbrInscrit: 3, fiduciareCa: 380 },
        //     },
        //     "2024-08": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 10, individuelCa: 980, fiduciareNbrInscrit: 6, fiduciareCa: 820 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 7, individuelCa: 700, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 280, fiduciareNbrInscrit: 3, fiduciareCa: 360 },
        //     },
        //     "2024-09": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 17, individuelCa: 1550, fiduciareNbrInscrit: 9, fiduciareCa: 1150 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 10, individuelCa: 950, fiduciareNbrInscrit: 5, fiduciareCa: 600 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 4, individuelCa: 350, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //     },
        //     "2024-10": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 12, individuelCa: 1250, fiduciareNbrInscrit: 7, fiduciareCa: 930 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 8, individuelCa: 780, fiduciareNbrInscrit: 4, fiduciareCa: 520 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 310, fiduciareNbrInscrit: 3, fiduciareCa: 390 },
        //     },
        //     "2024-11": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 13, individuelCa: 1350, fiduciareNbrInscrit: 8, fiduciareCa: 970 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 9, individuelCa: 880, fiduciareNbrInscrit: 5, fiduciareCa: 560 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 3, individuelCa: 300, fiduciareNbrInscrit: 3, fiduciareCa: 400 },
        //     },
        //     "2024-12": {
        //         "9": { silotId: 9, silotName: "MIPP_25", individuelNbrInscrit: 9, individuelCa: 950, fiduciareNbrInscrit: 5, fiduciareCa: 750 },
        //         "6": { silotId: 6, silotName: "Livre_IPP_25", individuelNbrInscrit: 6, individuelCa: 600, fiduciareNbrInscrit: 3, fiduciareCa: 410 },
        //         "4": { silotId: 4, silotName: "Livre_IPP_24", individuelNbrInscrit: 2, individuelCa: 200, fiduciareNbrInscrit: 2, fiduciareCa: 320 },
        //     },
        // };

        // const { coloredData1, coloredData2 } = this.addColorsToBothSilos(data1, data2);

        // const data = [
        //     { name: "activated", value: 90, color: "#02AF8E" },
        //     { name: "canceled", value: 10, color: "#FE3745" },
        // ];

        // const dataTwo = [
        //     { name: "activated", value: 50, color: "#29394D" },
        //     { name: "canceled", value: 100 - 50, color: "#D8DDE2" },
        // ];


        return (
            <div style={{ backgroundColor: '#F4F7F9', height: '100%', minHeight: '100vh' }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    padding: '30px 80px',
                }}>
                    <div style={{
                        color: '#29394D',
                        fontFamily: 'Roboto',
                        fontSize: '32px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: 'normal',
                        textTransform: 'uppercase',
                    }}>Statistiques Paper</div>
                    <PeriodFilterPaper onChangePeriod={this.handleChangePeriod} />
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginRight: '80px',
                        marginLeft: '80px',
                        gap: '20px',
                    }}
                >

                    <div className='flex' style={{ width: '80%', backgroundColor: '#FFFFFF', padding: '20px', justifyContent: `${nbrInscriptionFetch ? 'center' : 'space-between'}` }}>
                        {
                            nbrInscriptionFetch
                                ?
                                <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                                :
                                <React.Fragment>
                                    <div className='flex justify-between' style={{ width: '40%', flexDirection: 'column' }}>
                                        <BelgiumMapPaper cityPercentageData={this.state.cityPercentageData} firstVariant={firstVariant} secondVariant={secondVariant} thirdVariant={thirdVariant} />
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                            <div
                                                onClick={() => {
                                                    this.setState({ firstVariant: firstVariant - 10, secondVariant: secondVariant - 10, thirdVariant: thirdVariant - 10 });
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#000',
                                                    textAlign: 'end',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F1F2F4',
                                                    borderRadius: '50%',
                                                    height: '26px',
                                                    width: '26px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>-</div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <div style={{ width: '10px', height: '10px', backgroundColor: '#2d74d0' }} />
                                                <span style={{ color: '#000' }}>{` > ${firstVariant}`}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <div style={{ width: '10px', height: '10px', backgroundColor: '#4582e4' }} />
                                                <span style={{ color: '#000' }}>{` > ${secondVariant}`}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <div style={{ width: '10px', height: '10px', backgroundColor: '#88b0ed' }} />
                                                <span style={{ color: '#000' }}>{` > ${thirdVariant}`}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <div style={{ width: '10px', height: '10px', backgroundColor: '#dddddd' }} />
                                                <span style={{ color: '#000' }}>{` < ${thirdVariant}`}</span>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    this.setState({ firstVariant: firstVariant + 10, secondVariant: secondVariant + 10, thirdVariant: thirdVariant + 10 });
                                                }}
                                                style={{
                                                    cursor: 'pointer',
                                                    color: '#000',
                                                    textAlign: 'end',
                                                    cursor: 'pointer',
                                                    backgroundColor: '#F1F2F4',
                                                    borderRadius: '50%',
                                                    height: '26px',
                                                    width: '26px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                }}>+</div>
                                        </div>
                                    </div>
                                    <div className='flex' style={{ width: '60%', marginLeft: '20px', flexDirection: 'column', gap: '20px' }}>
                                        <h3 style={{
                                            fontFamily: 'Roboto',
                                            fontStyle: 'normal',
                                            fontWeight: '500',
                                            fontSize: '18px',
                                            lineHeight: '16px',
                                            color: '#29394D',
                                        }}>Top régions</h3>
                                        <div style={topFiveCityPercentageData.length > 0 ? { color: '#29394D' } : { color: '#29394D', width: '100%', height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {
                                                topFiveCityPercentageData.length > 0
                                                    ?
                                                    topFiveCityPercentageData.map((item, index) => (
                                                        <React.Fragment key={index}>
                                                            <Row
                                                                key={index}
                                                                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0px' }}
                                                            >
                                                                <Col span={19}>{item.region}</Col>
                                                                <Col span={2} style={{ borderRight: '1px solid #E1E4E8' }}>{item.nbrInscription}</Col>
                                                                <Col span={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>{item.ca / 100} €</Col>
                                                            </Row>
                                                            {
                                                                index !== topFiveCityPercentageData.length - 1 &&

                                                                <div style={{ width: '100%', height: '2px', backgroundColor: '#B2BCC6' }}>
                                                                    {
                                                                        item.ca === 0 ?
                                                                            <div style={{ width: `${Math.round((item.ca / topFiveCityPercentageData[0].ca) * 100)}%`, height: '2px', backgroundColor: '#dddddd' }} />
                                                                            :
                                                                            <div style={{ width: `${Math.round((item.ca / topFiveCityPercentageData[0].ca) * 100)}%`, height: '2px', backgroundColor: '#18A0FB' }} />
                                                                    }
                                                                </div>
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                    :
                                                    <div>
                                                        <p style={{ textAlign: 'center', color: '#999' }}>{_('Aucune donnée disponible')}</p>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </React.Fragment>
                        }
                    </div>
                    <div style={{ width: '20%', backgroundColor: '#FFFFFF', padding: '20px' }}>
                        {
                            typeInscritFetch || typeCAFetch
                                ?
                                <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                                :
                                <div className='flex' style={{ flexDirection: 'column', gap: '20px' }}>
                                    <h3 style={{
                                        fontFamily: 'Roboto',
                                        fontStyle: 'normal',
                                        fontWeight: '500',
                                        fontSize: '18px',
                                        lineHeight: '16px',
                                        color: '#29394D',
                                    }}>{('Rapport')}</h3>
                                    <PaperFilterInscriptionsCA
                                        activeTab={activeTabInscriptionsCA}
                                        onActiveTabChange={this.handleActiveTabInscriptionsCAChange}
                                    />
                                    <PaperChart typeInscritData={typeInscritData} typeCAData={typeCAData} activeTabTypeInscrit={activeTabInscriptionsCA} />
                                </div>
                        }
                    </div>
                </div>
                <div style={{ margin: '0 80px', marginTop: '40px', border: '1px solid #F1F2F4', background: '#FFF', paddingBottom: '20px' }}>
                    <div className="contribution-stats-nbr-chart" style={{ flexDirection: 'column', gap: '30px', padding: '30px' }}>
                        <div style={{ display: "flex", gap: 30, width: "100%", justifyContent: "space-between", alignItems: "center" }}>
                            <PaperFilterTypeSilo activeTab={activeTabTypeSilo} onActiveTabChange={this.handleActiveTabTypeSiloChange} />
                            <div style={{ width: "50%", display: 'flex', justifyContent: selectedFrequency === "DAILY" ? "space-between" : "flex-end", }}>
                                {
                                    selectedFrequency === "DAILY" &&
                                    <ReactSelect
                                        onChange={this.handleSelectChange}
                                        styles={newSeasonFilterStyle()}
                                        defaultValue={monthsForDailyForSelectDefault}
                                        options={monthsForDailyForSelect}
                                        components={{ DropdownIndicator, IndicatorSeparator: () => null, Input: () => null }}
                                    />
                                }
                                <div style={{ display: "flex", background: "#F0F0F0", borderRadius: 20, padding: 4 }}>
                                    {["DAILY", "MONTHLY", "YEARLY"].map((period) => (
                                        <button
                                            key={period}
                                            onClick={() => this.handleFrequencyChange(period)}
                                            style={{
                                                border: "none",
                                                padding: "6px 12px",
                                                borderRadius: 20,
                                                cursor: "pointer",
                                                background: selectedFrequency === period ? "#6D7F92" : "transparent",
                                                color: selectedFrequency === period ? "white" : "#555",
                                                fontWeight: selectedFrequency === period ? "bold" : "normal",
                                                width: "120px",
                                                height: "32px",
                                            }}
                                        >
                                            {t(period)}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                        {
                            activeTabTypeSilo === "type"
                                ?
                                <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                                    <PaperInscriptionsCAType data={silotData} handleToggleKey={this.handleToggleKeyType} visibleKeys={visibleKeysType} silotDataFetch={silotDataFetch} showCompare={showCompareStatsByType} onShowCompareStatsByType={this.handleShowCompareStatsByType} showCompareStats={showCompareStats} />
                                    <div style={{ width: '50%', display: 'flex', flexDirection: 'column', gap: '50px' }}>
                                        {silotDataFetch || showCompareStatsFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
                                            <React.Fragment>
                                                <PaperFilterInscriptionsCA
                                                    activeTab={activeTabInscriptionsCA}
                                                    onActiveTabChange={this.handleActiveTabInscriptionsCAChange}
                                                />
                                                {
                                                    showCompareStatsByType.all || showCompareStatsByType.individuel || showCompareStatsByType.fiduciare
                                                        ?
                                                        <PaperStatsChartLineTypeCompare data1={silotData} data2={silotData2} frequency={selectedFrequency} activeTab={activeTabInscriptionsCA} visibleKeys={visibleKeysType} year={period} showCompare={showCompareStatsByType} />
                                                        :
                                                        <PaperStatsChartLineType data={silotData} frequency={selectedFrequency} activeTab={activeTabInscriptionsCA} visibleKeys={visibleKeysType} />
                                                }
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>
                                :
                                <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                                    <PaperInscriptionsCASilo data={silotData} handleToggleKey={this.handleToggleKeySilo} visibleKeys={visibleKeysSilo} silotDataFetch={silotDataFetch} activeTabTypeSilo={activeTabTypeSilo} />
                                    <div style={{ width: '50%', display: 'flex', flexDirection: 'column', gap: '50px' }}>
                                        {silotDataFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
                                            <React.Fragment>
                                                <PaperFilterInscriptionsCA
                                                    activeTab={activeTabInscriptionsCA}
                                                    onActiveTabChange={this.handleActiveTabInscriptionsCAChange}
                                                />
                                                <PaperStatsChartLineSilo data={silotData} frequency={selectedFrequency} activeTab={activeTabInscriptionsCA} visibleKeys={visibleKeysSilo} />
                                            </React.Fragment>
                                        }
                                    </div>
                                </div>
                        }

                        {
                            showCompareStats && period > 2024 && (selectedFrequency == 'MONTHLY' || selectedFrequency == 'DAILY') && activeTabTypeSilo === "type"
                            &&
                            <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                                <PaperInscriptionsCATypeCompare data1={silotData} data2={silotData2} handleToggleKey={this.handleToggleKeyType} visibleKeys={visibleKeysType} silotDataFetch={silotDataFetch2} year={period} startMonth={startMonth} endMonth={endMonth} />
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column', gap: '50px' }}>
                                    {silotDataFetch2 ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
                                        <React.Fragment>
                                            {
                                                selectedFrequency === 'MONTHLY' &&
                                                <MonthFilterPaper
                                                    startMonth={startMonth}
                                                    endMonth={endMonth}
                                                    handleStartMonthChange={this.handleStartMonthChange}
                                                    handleEndMonthChange={this.handleEndMonthChange}
                                                />
                                            }
                                            <PaperFilterInscriptionsCA
                                                activeTab={activeTabInscriptionsCA}
                                                onActiveTabChange={this.handleActiveTabInscriptionsCAChange}
                                            />
                                            <PaperStatsChartLineTypeCompare data1={silotData} data2={silotData2} frequency={selectedFrequency} activeTab={activeTabInscriptionsCA} visibleKeys={visibleKeysType} year={period} startMonth={startMonth} endMonth={endMonth} />
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        }
                        {
                            showCompareStats && period > 2024 && (selectedFrequency == 'MONTHLY' || selectedFrequency == 'DAILY') && activeTabTypeSilo === "silo"
                            &&
                            <div style={{ width: '100%', display: 'flex', gap: '20px' }}>
                                <PaperInscriptionsCASiloCompare data1={silotData} data2={silotData2} handleToggleKey={this.handleToggleKeySilo} visibleKeys={visibleKeysSilo} silotDataFetch={silotDataFetch2} activeTabTypeSilo={activeTabTypeSilo} year={period} startMonth={startMonth} endMonth={endMonth} />
                                <div style={{ width: '40%', display: 'flex', flexDirection: 'column', gap: '50px' }}>
                                    {silotDataFetch2 ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
                                        <React.Fragment>
                                            {
                                                selectedFrequency === 'MONTHLY' &&
                                                <MonthFilterPaper
                                                    startMonth={startMonth}
                                                    endMonth={endMonth}
                                                    handleStartMonthChange={this.handleStartMonthChange}
                                                    handleEndMonthChange={this.handleEndMonthChange}
                                                />
                                            }
                                            <PaperFilterInscriptionsCA
                                                activeTab={activeTabInscriptionsCA}
                                                onActiveTabChange={this.handleActiveTabInscriptionsCAChange}
                                            />
                                            <PaperStatsChartLineSiloCompare data1={silotData} data2={silotData2} frequency={selectedFrequency} activeTab={activeTabInscriptionsCA} visibleKeys={visibleKeysSilo} year={period} startMonth={startMonth} endMonth={endMonth} />
                                        </React.Fragment>
                                    }
                                </div>
                            </div>
                        }

                        {
                            (selectedFrequency === "MONTHLY" || selectedFrequency == 'DAILY') && period > 2024 &&
                            <div className={"flex flex-col items-center mt-3"}>
                                <span className={"event-cycle-trainings"}
                                    onClick={() => this.handleShowCompareStats(!showCompareStats)}>{showCompareStats ? _("REDUCE") : _("COMPARE_WITH_ANOTHER_YEAR")}</span>
                                <div className={"event-cycle-chevron"}
                                    onClick={() => this.handleShowCompareStats(!showCompareStats)}>
                                    <img src="/img/icons/chevron-down.svg"
                                        className={showCompareStats && "cycle-stats-chevron-rotate"} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div style={{ margin: '0 80px', marginTop: '40px', paddingBottom: '20px' }}>
                    <div style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '30px', fontStyle: 'normal', fontWeight: '600', lineHeight: '36px', letterSpacing: '-0.3px' }}>Activités</div>
                    <Row style={{ marginTop: '20px', gap: '20px', color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500', paddingRight: '16px' }}>
                        <Col span={13} style={{ paddingLeft: '24px' }}>Titre Silo</Col>
                        <Col span={4}>Inscrits payants</Col>
                        <Col span={4}>Inscrits privé</Col>
                        <Col span={2}>Total</Col>
                        <Col span={1} />
                    </Row>
                    {
                        silotDataActivitiesFetch
                            ?
                            <CommonLoader containerHeight={"350px"} iconFontSize={"50px"} iconColor={"#29394D"} />
                            :
                            silotDataActivities && silotDataActivities.length > 0
                                ?
                                silotDataActivities
                                    .sort((a, b) => b.paidRegistration + b.NotpaidRegistration - (a.paidRegistration + a.NotpaidRegistration))
                                    .map((silot, index) => (
                                        <React.Fragment key={index}>
                                            <Row style={{ display: 'flex', alignItems: 'center', marginTop: '20px', backgroundColor: '#FFF', padding: '16px 16px 16px 0px', borderRadius: '5px', border: '1px solid #F1F2F4', borderLeft: '4px solid #18A0FB' }}>
                                                <Col span={13} style={{ display: 'flex', flexDirection: 'column', paddingLeft: '20px' }}>
                                                    <span style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500' }}>{silot.silotName}</span>
                                                </Col>
                                                <Col span={4} style={{ display: 'flex', flexDirection: 'column', paddingRight: '40px', gap: '5px' }}>
                                                    <span style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500' }}>{silot.paidRegistration}</span>
                                                    <div style={{ width: '100%', height: '5px', backgroundColor: '#D8DDE2', borderRadius: '5px' }}>
                                                        <div style={{ width: `${(silot.paidRegistration / (silot.paidRegistration + silot.NotpaidRegistration === 0 ? 1 : silot.paidRegistration + silot.NotpaidRegistration)) * 100}%`, height: '5px', backgroundColor: '#29394D', borderRadius: '5px' }} />
                                                    </div>
                                                </Col>
                                                <Col span={4} style={{ display: 'flex', flexDirection: 'column', paddingRight: '40px', gap: '5px' }}>
                                                    <span style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500' }}>{silot.NotpaidRegistration}</span>
                                                    <div style={{ width: '100%', height: '5px', backgroundColor: '#D8DDE2', borderRadius: '5px' }}>
                                                        <div style={{ width: `${(silot.NotpaidRegistration / (silot.paidRegistration + silot.NotpaidRegistration === 0 ? 1 : silot.paidRegistration + silot.NotpaidRegistration)) * 100}%`, height: '5px', backgroundColor: '#29394D', borderRadius: '5px' }} />
                                                    </div>
                                                </Col>
                                                <Col span={2}>
                                                    <span style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500' }}>{silot.paidRegistration + silot.NotpaidRegistration} inscriptions</span>
                                                </Col>
                                                <Col span={1} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                    <span onClick={() => this.handleToggleDetails(index, silot.silotId)} style={{ color: '#29394D', fontFamily: 'Roboto', fontSize: '14px', fontStyle: 'normal', fontWeight: '500', cursor: 'pointer', transform: openIndex === index ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                            <g clip-path="url(#clip0_2177_8533)">
                                                                <path d="M6.42831 9.12706L11.8229 3.73071C12.059 3.49392 12.059 3.11029 11.8229 2.8729C11.5867 2.63612 11.203 2.63612 10.9668 2.8729L6.00032 7.84122L1.0338 2.8735C0.797615 2.63671 0.413981 2.63671 0.177193 2.8735C-0.0589972 3.11029 -0.0589972 3.49452 0.177193 3.73131L5.57174 9.12766C5.80549 9.36086 6.19516 9.36086 6.42831 9.12706Z" fill="#6D7F92" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_2177_8533">
                                                                    <rect width="12" height="12" fill="white" transform="translate(12) rotate(90)" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                    </span>
                                                </Col>
                                            </Row>
                                            {
                                                openIndex === index && (
                                                    <div style={{ borderRadius: '5px', border: '1px solid #29394D', background: '#FFF', marginTop: '20px', padding: '16px' }}>
                                                        {
                                                            silotDetailsFetch
                                                                ?
                                                                <CommonLoader containerHeight={"100px"} iconFontSize={"30px"} iconColor={"#29394D"} />
                                                                :
                                                                <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <Col span={6} style={{ borderRadius: '5px', border: '1px solid #F1F2F4', background: '#FFF', padding: '13px' }}>
                                                                        <div style={{ color: '#29394D', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>Chiffre D'affaire</div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                                                                            <div>
                                                                                <img src="/img/icons/CA-ICON.svg" alt="" width={80} />
                                                                            </div>
                                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', color: '#29394D', fontSize: '12px', fontWeight: '400', gap: '5px', textTransform: 'uppercase' }}>
                                                                                    <span>HTVA :</span>
                                                                                    <span>TVA :</span>
                                                                                    <span>Total :</span>
                                                                                </div>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', color: '#29394D', fontSize: '12px', fontWeight: '500', gap: '5px' }}>
                                                                                    <span>{formatAmount(silotDetails.caHTVA)}</span>
                                                                                    <span>{formatAmount(silotDetails.catva)}</span>
                                                                                    <span>{formatAmount(silotDetails.caTVAC)}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={5} style={{ borderRadius: '5px', border: '1px solid #F1F2F4', background: '#FFF', padding: '13px' }}>
                                                                        <div style={{ color: '#29394D', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>Bon de commande</div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                            <PieChart width={100} height={100}>
                                                                                <Pie
                                                                                    data={[
                                                                                        { name: "activated", value: (Number(silotDetails.activeOrders) / (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders))) * 100, color: "#02AF8E" },
                                                                                        { name: "canceled", value: (Number(silotDetails.cancelledOrders) / (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders))) * 100, color: "#FE3745" },
                                                                                        { name: "all", value: (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders) === 0 ? 100 : 0), color: "#D8DDE2" }
                                                                                    ]}
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    innerRadius={35}
                                                                                    outerRadius={40}
                                                                                    dataKey="value"
                                                                                >
                                                                                    {[
                                                                                        { name: "activated", value: (Number(silotDetails.activeOrders) / (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders))) * 100, color: "#02AF8E" },
                                                                                        { name: "canceled", value: (Number(silotDetails.cancelledOrders) / (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders))) * 100, color: "#FE3745" },
                                                                                        { name: "all", value: (Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders) === 0 ? 100 : 0), color: "#D8DDE2" }
                                                                                    ].map((entry, index) => (
                                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                                    ))}
                                                                                </Pie>
                                                                                <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize={12} fontWeight="normal" fill="#2C3E50">
                                                                                    {Number(silotDetails.activeOrders) + Number(silotDetails.cancelledOrders)}
                                                                                </text>
                                                                            </PieChart>
                                                                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px', width: '100%' }}>
                                                                                <div style={{ color: '#02AF8E', fontSize: '10px', fontWeight: '600', width: '100%', textAlign: 'center', background: '#62DEB033', padding: '5px 0', borderRadius: '30px' }}>{Number(silotDetails.activeOrders)} Actives</div>
                                                                                <div style={{ color: '#FE3745', fontSize: '10px', fontWeight: '600', width: '100%', textAlign: 'center', background: '#FF636E33', padding: '5px 0', borderRadius: '30px' }}>{Number(silotDetails.cancelledOrders)} Annulées</div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={5} style={{ borderRadius: '5px', border: '1px solid #F1F2F4', background: '#FFF', padding: '13px' }}>
                                                                        <div style={{ color: '#29394D', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>Facture</div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                            <PieChart width={100} height={100}>
                                                                                <Pie
                                                                                    data={
                                                                                        [
                                                                                            { name: "paid", value: (Number(silotDetails.paidInvoices) / (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices))) * 100, color: "#02AF8E" },
                                                                                            { name: "not_paid", value: ((Number(silotDetails.notPaidInvoices) / (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices))) * 100), color: "#FE3745" },
                                                                                            { name: "all", value: (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices) === 0 ? 100 : 0), color: "#D8DDE2" }
                                                                                        ]
                                                                                    }
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    innerRadius={35}
                                                                                    outerRadius={40}
                                                                                    dataKey="value"
                                                                                >
                                                                                    {[
                                                                                        { name: "paid", value: (Number(silotDetails.paidInvoices) / (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices))) * 100, color: "#02AF8E" },
                                                                                        { name: "not_paid", value: ((Number(silotDetails.notPaidInvoices) / (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices))) * 100), color: "#FE3745" },
                                                                                        { name: "all", value: (Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices) === 0 ? 100 : 0), color: "#D8DDE2" }
                                                                                    ].map((entry, index) => (
                                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                                    ))}
                                                                                </Pie>
                                                                                <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize={12} fontWeight="normal" fill="#2C3E50">
                                                                                    {Number(silotDetails.paidInvoices) + Number(silotDetails.notPaidInvoices)}
                                                                                </text>
                                                                            </PieChart>
                                                                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px', width: '100%' }}>
                                                                                <div style={{ color: '#02AF8E', fontSize: '10px', fontWeight: '600', width: '100%', textAlign: 'center', background: '#62DEB033', padding: '5px 0', borderRadius: '30px' }}>{formatAmount(Number(silotDetails.sumPaidInvoices))} Payées</div>
                                                                                <div style={{ color: '#FE3745', fontSize: '10px', fontWeight: '600', width: '100%', textAlign: 'center', background: '#FF636E33', padding: '5px 0', borderRadius: '30px' }}>{formatAmount(Number(silotDetails.sumNotPaidInvoices))} Non payées</div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                    <Col span={7} style={{ borderRadius: '5px', border: '1px solid #F1F2F4', background: '#FFF', padding: '13px' }}>
                                                                        <div style={{ color: '#29394D', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>Taux de paiement</div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                                            <PieChart width={100} height={100}>
                                                                                <Pie
                                                                                    data={[
                                                                                        { name: "tauxPayment", value: silotDetails.tauxPayment, color: "#29394D" },
                                                                                        { name: "all", value: 100 - silotDetails.tauxPayment, color: "#D8DDE2" },
                                                                                    ]}
                                                                                    cx="50%"
                                                                                    cy="50%"
                                                                                    innerRadius={35}
                                                                                    outerRadius={40}
                                                                                    dataKey="value"
                                                                                >
                                                                                    {[
                                                                                        { name: "tauxPayment", value: silotDetails.tauxPayment, color: "#29394D" },
                                                                                        { name: "all", value: 100 - silotDetails.tauxPayment, color: "#D8DDE2" },
                                                                                    ].map((entry, index) => (
                                                                                        <Cell key={`cell-${index}`} fill={entry.color} />
                                                                                    ))}
                                                                                </Pie>
                                                                                <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize={12} fontWeight="normal" fill="#2C3E50">
                                                                                    {silotDetails.tauxPayment}%
                                                                                </text>
                                                                            </PieChart>
                                                                            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px', width: '100%' }}>
                                                                                <div style={{ color: '#29394D', fontSize: '12px', fontWeight: '400', width: '100%', textAlign: 'start' }}>Prix moyen par participant HTVA : <span style={{ color: '#29394D', fontWeight: '600', width: '100%', textAlign: 'start' }}>{formatAmount(silotDetails.moyenPricePerRegistrantHTVA, false)}</span></div>
                                                                                <div style={{ color: '#29394D', fontSize: '12px', fontWeight: '400', width: '100%', textAlign: 'start' }}>Prix moyen par participant : <span style={{ color: '#29394D', fontWeight: '600', width: '100%', textAlign: 'start' }}>{formatAmount(silotDetails.moyenPricePerRegistrant, false)}</span></div>
                                                                            </div>
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                        }
                                                    </div>
                                                )
                                            }
                                        </React.Fragment>
                                    ))
                                :
                                <div style={{ marginTop: '20px', padding: '20px', backgroundColor: '#FFF', border: '1px solid #F1F2F4', borderRadius: '5px' }}>
                                    <p style={{ textAlign: 'center', color: '#999' }}>{_('Aucune donnée disponible')}</p>
                                </div>
                    }
                </div>
            </div >
        );
    }
}

const mapStateToProps = state => ({
    eventStatsFilter: state.filters.eventStatsFilter,
});

const mapDispatchToProps = {
    startCommandGetSilotDetails,
    startCommandGetNbrInscritBySilot,
    getNbrInscritsCAPaperByRegion,
    getRapportInscritsPaper,
    getRapportCAPaper,
    startCommandGetNbrCaPaperByFrequency,
    getCommandInfo,
};

export default connect(mapStateToProps, mapDispatchToProps)(PaperStatisticsPage);



// WEBPACK FOOTER //
// ./app/pages/Admin/PaperStatisticsPage.js